var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("PostingCard", {
    staticClass:
      "flex flex-col posting_Card_container w-full sm:w-[355px] rounded-3xl p-4 bg-white shadow-sm hover:shadow-xl transition delay-75 duration-200 ease-in-out",
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "flex flex-col w-full" },
              [
                _c(
                  "RouterLink",
                  {
                    staticClass: "flex items-center",
                    class: _vm.getNameClasses,
                    attrs: {
                      to: {
                        name: _vm.routes.JOBBOARD_POSTING,
                        params: { id: _vm.posting.id },
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "leading-5 text-lg font-medium mb-5 inline text-badgeBlue",
                      },
                      [_vm._v(" " + _vm._s(_vm.posting.job_title) + " ")]
                    ),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "flex flex-col w-full xlLabelContainer" },
                  [
                    _c("div", { staticClass: "flex gap-1.5 flex-col" }, [
                      !_vm.isMarketplace
                        ? _c(
                            "div",
                            { staticClass: "flex items-center text-sm" },
                            [
                              _c(
                                "p",
                                { staticClass: "w-36 flex items-center gap-2" },
                                [
                                  _c("CompanyIcon", {
                                    staticClass: "h-4 w-4",
                                    attrs: { fill: "#000000" },
                                  }),
                                  _vm._v(" Company "),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-storm-gray" }, [
                                _vm._v(
                                  _vm._s(_vm.posting.company.business_name)
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _c("div", { staticClass: "flex items-center text-sm" }, [
                        _c(
                          "p",
                          { staticClass: "w-36 flex items-center gap-2" },
                          [
                            _c("UserIcon", {
                              staticClass: "h-4 w-4",
                              attrs: { fill: "#000000" },
                            }),
                            _vm._v(" Type "),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-storm-gray" }, [
                          _vm._v(_vm._s(_vm.type)),
                        ]),
                      ]),
                      _c("div", { staticClass: "flex items-center text-sm" }, [
                        _c(
                          "p",
                          { staticClass: "w-36 flex items-center gap-2" },
                          [
                            _c("LocationIcon", {
                              staticClass: "h-4 w-4",
                              attrs: { fill: "#000000" },
                            }),
                            _vm._v(" Location "),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "text-storm-gray",
                            class: _vm.getLocationClasses,
                          },
                          [_vm._v(_vm._s(_vm.location))]
                        ),
                      ]),
                      _c("div", { staticClass: "flex items-center text-sm" }, [
                        _c(
                          "p",
                          { staticClass: "w-36 flex items-center gap-2" },
                          [
                            _c("PinIcon", { staticClass: "h-4 w-4" }),
                            _vm._v(" Posted "),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-storm-gray" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("moment")(
                                _vm.posting.created_at,
                                "D MMM, YYYY"
                              )
                            )
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "flex items-center text-sm" }, [
                        _c(
                          "p",
                          { staticClass: "w-36 flex items-center gap-2" },
                          [
                            _c("Calendar", { staticClass: "h-4 w-4" }),
                            _vm._v(" Duration "),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-storm-gray" }, [
                          _vm._v(_vm._s(_vm.jobDuration)),
                        ]),
                      ]),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c("ItemsRenderer", {
              staticClass: "pt-2",
              attrs: {
                items: _vm.skills,
                title: "Skills",
                content_class: "ml-7",
                showMoreAfter: 3,
                chipClass: "b-recruite_chip_class",
              },
            }),
            _c("ItemsRenderer", {
              attrs: {
                items: _vm.industries,
                title: "Industries",
                content_class: "ml-1",
                showMoreAfter: 3,
                chipClass: "b-recruite_chip_class",
              },
            }),
            _c("ApplyButton", {
              staticClass: "ml-auto mt-4",
              attrs: {
                buttonClasses: "customButtonCardApply",
                applicationId: _vm.applicationId,
                isCancelled: _vm.isApplicationCancelled,
                postingId: _vm.posting.id,
                currentUserId: _vm.currentUserId,
                size: "lg",
                showIcon: false,
              },
              model: {
                value: _vm.applicationExists,
                callback: function ($$v) {
                  _vm.applicationExists = $$v
                },
                expression: "applicationExists",
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }